$(document).ready(function() {
  $(document).on('click', '.bio-nav-item', function() {
    var $this = $(this);
    var activeItem = $this.data('nav');

    $('.js-bio-nav-menu').find('.bio-nav-item').removeClass('bio-nav-item_active');
    $('.js-bio-nav-menu').find('.bio-nav-item[data-nav =' + activeItem + ']').addClass('bio-nav-item_active');
  });

  $(document).on('click', ('.js-bio-burger'), function (event) {
    event.preventDefault();
    var $this = $(this);

    $this.toggleClass('active');
    $('.js-bio-menu').toggleClass('active');
  });
});
